<template>
  <div class="detailTab">
    <div class="detailTab__nav">
      <a
        class="detailTab__nav--icon"
        v-on:click="detail = '1'"
        v-bind:class="[detail === '1' ? 'acc_deet' : '']"
        ><font-awesome-icon icon="clipboard-list" /> مشخصات
      </a>
      <a
        class="detailTab__nav--icon"
        v-on:click="detail = '2'"
        v-bind:class="[detail === '2' ? 'acc_deet' : '']"
      >
        <font-awesome-icon icon="comments" /> نظرات کاربران
      </a>
    </div>
    <div class="detailTab__body" v-if="detail == '1'">
      <div class="" v-if="this.$store.state.info.length != 0">
        <div
          :key="(item, index)"
          v-for="(item, index) in this.$store.state.info"
          class="detail_du"
        >
          <p class="detail_du_name">{{ item.feature }}</p>
          <p class="detail_du_define">
            &nbsp;
            <span
              >{{
                item.value.toLocaleString("fa").toPersianDigits()
              }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
            >
          </p>
        </div>
      </div>
      <p
        v-if="this.$store.state.ddd != null"
        class="deee"
        v-html="this.$store.state.ddd"
      ></p>
    </div>
    <div class="detailTab__body" v-if="detail == '2'">
      <div class="detailTab__body--create-comment">
        <div class="con4">
          <input
            v-if="show"
            class="detailTab__body--create-comment-name"
            type="text"
            placeholder="نام*"
            v-model="comment.name"
          />
          <input
            v-if="show"
            class="detailTab__body--create-comment-email"
            type="text"
            placeholder="ایمیل*"
            v-model="comment.email"
          />
        </div>
        <input
          class="detailTab__body--create-comment-title"
          type="text"
          placeholder="موضوع*"
          v-model="comment.title"
        />
        <textarea
          class="detailTab__body--create-comment-dec"
          name=""
          id=""
          cols="30"
          rows="10"
          v-model="comment.dec"
          placeholder="متن*"
        ></textarea>
        <a
          @click.prevent="sendComment"
          href=""
          class="detailTab__body--create-comment-btn"
          >ارسال نظر</a
        >
      </div>
      <div
        :key="(item, index)"
        v-for="(item, index) in this.$store.state.comments.results"
        class="detailTab__body--comments"
      >
        <div class="v1">
          <div class="v2">
            <div class="detailTab__body--comments--name">
              <font-awesome-icon icon="user" /> {{ item.name }}
            </div>
            <div class="detailTab__body--comments--date">
              {{ item.created_jalali }}
            </div>
          </div>
          <div class="">
            <div class="detailTab__body--comments--title">
              {{ item.title }}
            </div>
            <div class="detailTab__body--comments--disc">
              {{ item.content }}
            </div>
          </div>
        </div>

        <div
          class="rep"
          :key="(item, index)"
          v-for="(item, index) in item.replies"
        >
          <div class="">
            <div class="rep-name">مدیر فروشگاه</div>
            <p class="rep-time">{{ item.created_jalali }}</p>
          </div>
          <p class="rep-dec">{{ item.content }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  created() {
    var that = this;
    if (localStorage.getItem("profile") != null) {
      this.show = false;
    }
    String.prototype.toPersianDigits = function () {
      var id = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
      return this.replace(/[0-9]/g, function (w) {
        return id[+w];
      });
    };
    that.$store.state.load = true;
    // console.log("sss");
    // console.log(this.$store.state.pId);
  },
  data() {
    return {
      list: [],
      show: true,
      detail: "1",
      comment: {
        dec: "",
        name: "",
        email: "",
        title: "",
      },
    };
  },
  methods: {
    sendComment() {
      function validateEmail(email) {
        const re =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
      }
      var that = this;
      that.$store.state.load = true;
      if (localStorage.getItem("profile") == null) {
        if (
          that.comment.name.length == 0 ||
          that.comment.email.length == 0 ||
          that.comment.title.length == 0 ||
          that.comment.dec.length == 0
        ) {
          that.$toastr.e("لطفا فیلد های ضروری را پر کنید");
          that.$store.state.load = false;
        } else if (that.comment.name.length > 127) {
          that.$toastr.e("طول نام شما باید کم تر از ۱۲۷ کارکتر باشد");
          that.$store.state.load = false;
        } else if (!validateEmail(that.comment.email)) {
          that.$toastr.e("لطفا آدرس ایمیل معتبر وارد کنید");
          that.$store.state.load = false;
        } else if (that.comment.title.length > 127) {
          that.$toastr.e("طول موضوع شما باید کم تر از ۱۲۷ کارکتر باشد");
          that.$store.state.load = false;
        } else {
          $.ajax({
            url:
              that.$store.state.url +
              "api/v1/products/comment/create/" +
              this.$store.state.pId +
              "/",
            crossDomain: true,
            xhrFields: {
              withCredentials: true,
            },
            type: "POST",
            data: {
              name: that.comment.name,
              email: that.comment.email,
              title: that.comment.title,
              content: that.comment.dec,
            },
            success: function (data, textStatus, request) {
              // console.log(data);
              that.$toastr.s(data);
            },
            error: function (request, textStatus, errorThrown) {
              if (request.state == 500) {
                that.$toastr.e("خطایی در سرور به وجود امده");
                that.$store.state.e500 = true;
              } else {
                that.$store.state.e404 = true;
                that.$toastr.e("خطا در برقراری ارتباط");
              }
            },
            complete: function () {
              that.$store.state.load = false;
            },
          });
        }
      } else {
        if (that.comment.title.length == 0 || that.comment.dec.length == 0) {
          that.$toastr.e("لطفا فیلد های ضروری را پر کنید");
          that.$store.state.load = false;
        } else if (that.comment.title.length > 127) {
          that.$toastr.e("طول موضوع شما باید کم تر از ۱۲۷ کارکتر باشد");
          that.$store.state.load = false;
        } else {
          $.ajax({
            url:
              that.$store.state.url +
              "api/v1/products/comment/create/" +
              this.$store.state.pId +
              "/",
            crossDomain: true,
            headers: {
              Authorization: "Bearer" + " " + localStorage.getItem("profile"),
            },
            xhrFields: {
              withCredentials: true,
            },
            type: "POST",
            data: {
              name: that.comment.name,
              email: that.comment.email,
              title: that.comment.title,
              content: that.comment.dec,
            },
            success: function (data, textStatus, request) {
              // console.log(data);
              that.$toastr.s(data);
            },
            error: function (request, textStatus, errorThrown) {
              if (request.state == 500) {
                that.$toastr.e("خطایی در سرور به وجود امده");
                that.$store.state.e500 = true;
              } else {
                that.$store.state.e404 = true;
                that.$toastr.e("خطا در برقراری ارتباط");
              }
            },
            complete: function () {
              that.$store.state.load = false;
            },
          });
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.rep {
  padding: 0 3em;
  padding-top: 1em;
  display: flex;
  // background: red;
  height: auto;
  border-top: 1px solid var(--bg-color);
  @media screen and (max-width: 500px) {
    flex-direction: column;
    padding-right: 0.5em;
  }
  &-name {
    width: 80px;
    font-size: 0.9em;
    color: var(--sub-color);
    // margin-right: em;
  }
  &-dec {
    padding: 0 3em;
    padding-top: 1.2em;
    @media screen and (max-width: 500px) {
      // flex-direction: column;
      // background: red;
      // width: 100% !important;
      // padding-right: 2em;
      padding: 0;
      margin-top: 0.5em;
      margin-right: 0.5em;
      text-align: right;
    }
  }
  &-time {
    font-size: 0.5em;
  }
}

.rrrr {
  width: 100%;
  border: none;
  height: 1px;
  margin-top: 1em;
  background-color: #cfd8dca2;
}
.dadad {
  width: 100%;
  border: none;
  height: 1px;
  margin-top: 1em;
  background-color: #cfd8dc9a;
}
.detailTab {
  width: 98%;
  border-radius: 10px;
  height: auto;
  background: var(--main-color);
  margin: 3em;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.24);
  display: flex;
  direction: rtl;
  @media screen and (max-width: 500px) {
  }
  &__body {
    width: 100%;
    // background: red;
    margin-top: 2em;
    padding: 2em;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    @media screen and (max-width: 900px) {
      font-size: 0.8em;
    }
    &--create-comment {
      display: flex;
      flex-direction: column;
      &-title {
        width: 98.8% !important;
        margin: 0.5em !important;
        // background: red !important;
      }
      &-btn {
        margin-right: auto;
        text-decoration: none;
        color: var(--main-color);
        background: var(--sub-color);
        padding: 0.45em 3em;
        border-radius: 5px;
        margin-left: 0.5em;
        width: 200px;
        text-align: center;
        margin-top: 0.5em;

        @media screen and (max-width: 500px) {
          font-size: 0.8em;
          width: 100px;
          padding: 0.45em 0.5em;
          margin-right: auto;
          margin-left: -0.5em;
        }
      }
      .con4 {
        display: flex;
        width: 100%;
        justify-content: center;
        align-items: center;
        // background: red;
        @media screen and (max-width: 500px) {
          flex-wrap: wrap;
          padding-right: 0.2em;
          // background: red;
          margin-right: 0.22em;
        }
      }
      input {
        margin: 0.5em;
        background: var(--bg-color);
        border: none;
        padding: 0.5em 1em;
        border-radius: 5px;
        font-family: "yekan";
        width: 100%;
        color: var(--font-color);
        box-shadow: 0 0 1px rgba(0, 0, 0, 0.226);
        @media screen and (max-width: 500px) {
          margin: 0.5em 0;
          // padding: 0 1em 0 0;
          // margin-right: em;
        }
        &:focus {
          outline: var(--sub-color);
        }
      }
      textarea {
        color: var(--font-color);
        margin: 0.5em;
        background: var(--bg-color);
        border: none;
        padding: 0.5em 1em;
        border-radius: 8px;
        font-family: "yekan";
        box-shadow: 0 0 1px rgba(0, 0, 0, 0.226);
        max-width: 98.8%;
        min-width: 98.8%;
        &:focus {
          outline: var(--sub-color);
        }
      }
    }
    &--comments {
      width: 100%;
      min-height: 250px;
      display: flex;
      flex-direction: column;
      margin-top: 3em;
      overflow: hidden;
      padding-bottom: 3em;
      @media screen and (max-width: 500px) {
        font-size: 0.7em;
        // flex-direction: row;
      }

      &:not(:last-child) {
        border-bottom: 1px solid var(--shrink);
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.144);
      }
      .v1 {
        // background: red;
        display: flex;

        @media screen and (max-width: 500px) {
          // font-size: 0.7em;
          flex-direction: column;
        }
      }
      &--name {
        padding: 1em;
        // background: red;
        min-width: 300px;
        color: var(--shrink);
        @media screen and (max-width: 900px) {
          min-width: 200px;
        }
      }
      &--date {
        padding: 0 1em;
      }
      &--title {
        border-bottom: 1px solid #cfd8dc;
        padding: 1em 0;
        font-size: 1.2em;
        width: 100%;
        // background: red;
        display: block;
        @media screen and (max-width: 500px) {
          border-bottom: none;
          padding: 1em;
        }
      }
      &--disc {
        padding: 2em 0em;
        // width: 100%;
        // background: red;
        // border-bottom: 1px solid #cfd8dc;
        @media screen and (max-width: 500px) {
          border-bottom: none;
          padding: 0 1em;
          margin-bottom: 1em;
        }
      }
      //   background: red;
    }
    .detail_du {
      display: flex;
      width: 100%;
      font-size: 0.9em;
      margin-bottom: 1em;
      // background: red;
      &_name {
        width: 20%;
        display: block;
        background: #fafafa;
        padding: 14px 18px 12px;
        font-size: 13px;
        font-size: 0.929rem;
        line-height: 1.692;
        color: var(--sub-color);
        letter-spacing: -0.3px;
        min-height: 47px;
        margin-left: 1em;
        @media screen and (max-width: 500px) {
          font-size: 1em;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      &_define {
        background: #fafafa;
        padding: 14px 18px 12px;
        font-size: 13px;
        font-size: 0.929rem;
        line-height: 1.692;
        color: var(--font-color);
        letter-spacing: -0.3px;
        min-height: 47px;
        margin-left: 1em;
        width: 80%;
        @media screen and (max-width: 500px) {
          font-size: 1em;
          display: flex;
          // justify-content: center;
          align-items: center;
        }
      }
    }
  }
  &__nav {
    position: absolute;
    transform: translate(-5%, -60%);
    // margin-top: -1em;
    // margin-right: 2em;
    // right: 0;
    // top: 0;
    &--icon {
      cursor: pointer;
      margin-left: 0.5em;
      background: var(--main-color);
      padding: 0.5em 2.5em;
      //   margin-top: -5em;
      z-index: 9 !important;
      background: var(--main-color);
      border-radius: 10px;
      box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.212);
      // opacity: 85% !important;
      //   font-family: "lalezar";
      //   font-size: 1.5em;
      text-align: center;
      color: var(--font-color);
      @media screen and (max-width: 500px) {
        font-size: 0.8em;
        border-radius: 5px;
        box-shadow: 0 -2px 2px rgba(0, 0, 0, 0.112);
      }
      svg {
        margin-left: 0.5em;
      }
    }
  }
}
.acc_deet {
  // opacity: 100% !important;
  //   box-shadow: 0 -3px 2px rgba(0, ;
  // border-bottom: 1px solid var(--shrink);
  color: var(--shrink);
  box-shadow: 0 0px 5px rgba(0, 0, 0, 0.212);
}
.deee {
  // overflow-x: hidden;
  // height: auto;
  // background: red;
  // display: flex;
  display: inline;
  margin-top: 1em;
  font-size: 0.8em;
  color: var(--font-color);
  // white-space: pre;
  width: 100%;
  white-space: pre-line;
  text-align: justify;
}
</style>



// WEBPACK FOOTER //
// src/components/detail/detailTab.vue